import { classNames } from '@core/utils/functions/class-names';

import Episode from '@/types/pages/api/podcasts/Episode';
import Podcast from '@/types/pages/api/podcasts/Podcast';

import SectionHeader from '@/components/display/headers/SectionHeader';
import PodcastsSection from '../../frontpage/components/Podcasts/PodcastsSection';
import EpisodeHead from '../components/EpisodeHead/EpisodeHead';

type PodcastEpisodePageProps = {
    podcast: Podcast;
    episode: Episode;
};

const PodcastEpisodePage = (props: PodcastEpisodePageProps) => {
    const { episode, podcast } = props;

    return (
        <main>
            <div>
                <EpisodeHead
                    episode={episode}
                    podcastSlug={podcast.slug}
                    podcastTitle={podcast.title}
                    imageUrl={podcast.imageFile || episode.imageFile}
                    spotifyLink={episode.spotifyIdentifier || ''}
                    appleLink={''}
                />
            </div>
            <div className="flex flex-col-reverse sm:flex-col lg:flex-row border-b">
                {/*
                <EpisodeSidebar />
                <EpisodeContent />
                */}
            </div>
            <div>
                <SectionHeader title="Other Podcasts from our Network" linkTitle={''} className="border-b" />
                <PodcastsSection
                    excludePodcasts={[podcast.slug]}
                    className={classNames(
                        'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4'
                        // 'touch-scroll', // only scroll via touchpad
                        // 'xl:flex xl:flex-row xl:overflow-x-auto xl:flex-nowrap xl:max-w-full px-8 w-full'
                    )}
                />
            </div>
        </main>
    );
};

export default PodcastEpisodePage;
